import APIKit from '../Allapis/Apikit/apikit'

export const getSeeksServer = async () => {
  const endpoint = 'seek'
  const res = await APIKit.get(endpoint)
  return res.data
}
